import AlarmExpandableContent from "./AlarmExpandableContent";

export default AlarmExpandableContent